<template>
  <div class="content clearfix" :class="{hide:false}" :style="{'padding-left':$route.query.partnerId == 23?'0px':'0px'}">
    <!-- 返回上级、证据下载 -->
    <div v-if="isShowTop" class="top">
      <a class="back" v-if="queryUrlParams.from == 'truthso_search' " @click="back(false)" href="javascript:;">返回上级</a>
      <a class="back" v-else @click="back(true)" href="javascript:;">返回上级</a>
      <a class="middle-download" @click="attachDownLoad" v-show="canAttachment">附件下载</a>
      <a class="right-download" :href="downloadUrl">证据下载</a>
    </div>
    <!-- 通用证书预览 -->
    <div class="certificate clearfix" :style="{'width':$route.query.partnerId==23?'1150px':'990px'}">
      <SaveCommonCertificate v-if="($route.query.type ==6 || $route.query.type ==7 || $route.query.type ==8) && $route.query.partnerId!=23" :certificateType="certificateType" :certificateList="list"></SaveCommonCertificate>
      <CommonCertificate v-else :certificateType="certificateType" :certificateList="list"></CommonCertificate>
      <template v-if="(list.previewCertificateTitle && list.previewCertificateTitle ==1) || ($route.query.type !=6 && $route.query.type !=7) || $route.query.partnerId == 23">
      <!-- 确权证据预览 -->
      <div class="exhibition" v-if="list.productType == 1" >
        <div class="exhibition-header" v-if="isHeader">
          <div class="exhibition-icon" style="width: 100px;height:45px;">
            <img src="../../assets/images/common/pdf/enlarge.png" style="margin: 10px 13px;cursor: pointer;float:left;" @click="pluss">
            <img src="../../assets/images/common/pdf/rotate.png" style="margin: 10px 13px;cursor: pointer;float:right;" @click="imgRotate">
          </div>
        </div>
        <div class="pdfLoading" v-if="list.type == 1 && pdfObject.loading">
          <img src="../../assets/images/common/data-loading.gif">
        </div>
        <div class="exhibition-content" :class="{'padding_top':!isHeader}">
          <!-- 文档 -->
          <div v-show="list.type == 1" style="overflow:hidden;">
            <div class="exhibition-header" style="position: static;">
              <div class="exhibition-icon" style="width: 50px;">
                <img v-if="!pdfObject.zoom" src="../../assets/images/common/pdf/enlarge.png" style="margin:10px auto;cursor: pointer;" @click="pdfZoom(true)">

                <img src="../../assets/images/common/pdf/narrow.png" style="margin:10px auto;cursor: pointer;" @click="pdfZoom(false)" v-else>
              </div>
              <span style="display: block;margin: 0 auto;text-align: center;line-height: 40px;margin-left: 50px;">
                {{pdfObject.currentIndex}} / {{pdfObject.totalNumber}}
              </span>
            </div>
            <img src="../../assets/images/common/pdf/left.png" class="pdf_left" @click="changePage(true)">
            <img src="../../assets/images/common/pdf/right.png" class="pdf_right" @click="changePage(false)">
            <canvas style="cursor: pointer;width:460px;height:620px;" id="theCanvas" ref="theCanvas" width="100%" height="100%" @click="pdfZoom(true)"></canvas>
            <div v-show="!showRightsVideo" style="position: absolute;left: 50%; top: 50%; transform: translate(-50%, -50%)">
              <img src="../../assets/images/common/hideVideo.png" style="margin: 0 auto;">
              <p style="width: 260px;color: #666;margin:20px auto 0px;display: block">很抱歉，暂时不支持此格式文件的预览，请下载证据查看。</p>
            </div>
          </div>
          <!-- 图片 -->
          <div  class="img-content" v-if="list.type == 2"  :class="{'scrolled': isPlus}">
            <img v-show="showPic" :class="{'isPlus': isPlus}" :style="{width: ImgWidth, height: ImgHeight, 'margin-left': ImgLeft, 'margin-top': ImgTop, 'transform': rotateDeg}" :src="list.filePath" @click="pluss" style="cursor: pointer;">
          </div>
          <!-- 音频 -->
          <div v-if="list.type == 3" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <audio :src="list.filePath" controls="controls" width="100%" height="386"></audio>
          </div>
          <!-- 视频 -->
          <div v-show="list.type == 4 && domView || list.type == 6 " style="position:relative;width:100%;height:100%;overflow: hidden;">
            <video :src="list.filePath" ref="video" v-show="showRightsVideo" controls="controls" width="100%" height="386"></video>
            <div v-show="!showRightsVideo" style="position: absolute;left: 50%; top: 50%; transform: translate(-50%, -50%)">
              <img src="../../assets/images/common/hideVideo.png" style="margin: 0 auto;">
              <p style="width: 260px;color: #666;margin:20px auto 0px;display: block">很抱歉，暂时不支持此格式文件的预览，请下载证据查看。</p>
            </div>
            <!--  -->
          </div>
          <!-- 脱敏 -->
          <div v-if="list.type == 5" class="img-content" style="background-color: lightgray;height:100%;">
            <div style="position: absolute;left: 50%; top: 50%; transform: translate(-50%, -50%)">
              <img src="../../assets/images/common/hideVideo.png" style="margin: 0 auto;">
              <p style="width: 260px;color: #666;margin:20px auto 0px;display: block">脱敏确权证据不支持预览功能。</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 自主取证证据预览 -->
      <div class="exhibition" v-if="list.productType == 2">
        <div class="exhibition-header" v-if="isHeader">
          <div class="exhibition-icon" style="width: 100px;height:45px;">
            <img src="../../assets/images/common/pdf/enlarge.png" style="margin: 10px 13px;cursor: pointer;float:left;" @click="pluss">
            <img src="../../assets/images/common/pdf/rotate.png" style="margin: 10px 13px;cursor: pointer;float:right;" @click="imgRotate">
          </div>
        </div>
        <div class="exhibition-content" :class="{'padding_top':!isHeader}">
          <!-- 录屏 -->
          <div v-if="list.type == 1" style="overflow: hidden;">
            <video :src="list.filePath" controls="controls" width="100%" height="386"></video>
          </div>
          <!-- 快照 -->
          <div v-if="list.type == 2" class="img-content" :class="{'scrolled': isPlus}">
            <img v-show="showPic" :class="{'isPlus': isPlus, 'scrolled': isPlus}" v-bind:style="{width: ImgWidth, height: ImgHeight, 'margin-left': ImgLeft, 'margin-top': ImgTop, 'transform': rotateDeg}" :src="list.filePath" @click="pluss" style="cursor: pointer;">
          </div>
          <!-- 移动互联网 -->
          <div v-if="list.type == 3" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <video :src="list.filePath" controls="controls" width="100%" height="386"></video>
          </div>
          <!-- 过程 -->
          <div v-if="list.type == 4 || list.type == 6" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <video :src="list.filePath" controls="controls" width="100%" height="386"></video>
          </div>
        </div>
      </div>
      <!-- 现场取证证据预览 -->
      <div class="exhibition" v-if="list.productType == 3">
        <div class="exhibition-header" v-if="isHeader">
          <div class="exhibition-icon" style="width: 100px;height:45px;">
            <img src="../../assets/images/common/pdf/enlarge.png" style="margin: 10px 13px;cursor: pointer;float:left;" @click="pluss">
            <img src="../../assets/images/common/pdf/rotate.png" style="margin: 10px 13px;cursor: pointer;float:right;" @click="imgRotate">
          </div>
        </div>
        <div class="exhibition-content" :class="{'padding_top':!isHeader}">
          <!-- 图片 -->
          <div v-if="list.type == 50001" class="img-content" :class="{'scrolled': isPlus}">
            <img v-show="showPic" :class="{'_rotate': isRotate, 'isPlus': isPlus, 'scrolled': isPlus }" :style="{'width': ImgWidth, 'height': ImgHeight, 'margin-left': ImgLeft, 'margin-top': ImgTop, 'transform': rotateDeg}" :src="list.filePath" @click="pluss" style="cursor: pointer;">
          </div>
          <!-- 音频 -->
          <div v-if="list.type == 50002 || list.type == 50004" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <audio :src="list.filePath" controls="controls" width="100%" height="386"></audio>
          </div>
          <!-- 视频 -->
          <div v-if="list.type == 50003 || list.type == 50005" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <video :src="list.filePath" controls="controls" width="100%" height="386"></video>
          </div>
        </div>
      </div>
      <!-- 对接调节平台证据预览 -->
      <div class="exhibition" v-if="$route.query.partnerId==23" style="width:555px;float: right;height:818px;margin-top: 29px;">
        <div class="exhibition-header" v-if="isHeader">
          <div class="exhibition-icon" style="width: 100px;height:45px;">
            <img src="../../assets/images/common/pdf/enlarge.png" style="margin: 10px 13px;cursor: pointer;float:left;" @click="pluss">
            <img src="../../assets/images/common/pdf/rotate.png" style="margin: 10px 13px;cursor: pointer;float:right;" @click="imgRotate">
          </div>
        </div>
        <div class="pdfLoading" v-if="list.type == 2 && pdfObject.loading">
          <img src="../../assets/images/common/data-loading.gif">
        </div>
        <div class="exhibition-content" :class="{'padding_top':!isHeader}">
          <!-- 文档 -->
          <div v-show="list.type == 2" style="overflow:hidden;">
            <div class="exhibition-header" style="position: static;">
              <div class="exhibition-icon" style="width: 50px;">
                <img v-if="!pdfObject.zoom" src="../../assets/images/common/pdf/enlarge.png" style="margin:10px auto;cursor: pointer;" @click="pdfZoom(true)">

                <img src="../../assets/images/common/pdf/narrow.png" style="margin:10px auto;cursor: pointer;" @click="pdfZoom(false)" v-else>
              </div>
              <span style="display: block;margin: 0 auto;text-align: center;line-height: 40px;margin-left: 50px;">
                {{pdfObject.currentIndex}} / {{pdfObject.totalNumber}}
              </span>
            </div>
            <img src="../../assets/images/common/pdf/left.png" class="pdf_left" @click="changePage(true)">
            <img src="../../assets/images/common/pdf/right.png" class="pdf_right" @click="changePage(false)">
            <canvas style="cursor: pointer;width:460px;height:620px;" id="theCanvas" ref="theCanvas" width="100%" height="100%" @click="pdfZoom(true)"></canvas>
            <div v-show="!showRightsVideo" style="position: absolute;left: 50%; top: 50%; transform: translate(-50%, -50%)">
              <img src="../../assets/images/common/hideVideo.png" style="margin: 0 auto;">
              <p style="width: 260px;color: #666;margin:20px auto 0px;display: block">很抱歉，暂时不支持此格式文件的预览，请下载证据查看。</p>
            </div>
          </div>
          <!-- 音频 -->
          <div v-if="list.type == 6" style="position:relative;width:100%;height:386px;overflow: hidden;">
            <audio :src="list.filePath" controls="controls" width="100%" height="386"></audio>
          </div>
          <!-- 视频 -->
          <div v-show="list.type == 3 " style="position:relative;width:100%;height:100%;overflow: hidden;">
            <video :src="list.filePath" ref="video" v-show="showRightsVideo" controls="controls" width="100%" height="386"></video>
            <div v-show="!showRightsVideo" style="position: absolute;left: 50%; top: 50%; transform: translate(-50%, -50%)">
              <img src="../../assets/images/common/hideVideo.png" style="margin: 0 auto;">
              <p style="width: 260px;color: #666;margin:20px auto 0px;display: block">很抱歉，暂时不支持此格式文件的预览，请下载证据查看。</p>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
      </template>
    </div>

    <!-- 新版本证书（增加区块链） -->

    <!-- img放大 -->
    <div class="img_modal" v-if="isPlus"></div>
    <div class="img_box" v-if="isPlus">
      <img id="imgNatural" :src="list.filePath" :style="{'transform': rotateDeg,'width':naturalWidth+'px'}" style="margin:10px auto;margin-top:50px;cursor: pointer;max-width: 1540px;" @click="reduce">
    </div>
    <div v-if="isPlus" style="position: absolute;width:89%;left: 49.5%;top: 10px;transform: translate(-50%,0);z-index: 99999;background-color:#fff;">
      <div style="width: 100%;height: 45px;border-bottom: solid 1px #b4bec3;position:relative;">
        <div class="preview">
          <span class="add" v-on:click="reducePer()">－</span>
          <span class="num">{{percentage + '%'}}</span>
          <span class="add " v-on:click="addPer()">＋</span>
          <span class="reset" v-on:click="reset()">重置</span>
        </div>
        <div class="exhibition-icon" style="width: 100px;height:45px;">
          <img src="../../assets/images/common/pdf/narrow.png" style="margin: 10px 13px;cursor: pointer;float:left;" @click="reduce">
          <img src="../../assets/images/common/pdf/rotate.png" style="margin: 10px 13px;cursor: pointer;float:right;" @click="imgRotate">
        </div>
      </div>
    </div>
    <!-- pdf Start -->

    <div class="pdf_modal" v-show="pdfObject.zoom"></div>
    <div class="pdf_box" v-show="pdfObject.zoom">
      <canvas id="newCanvas" ref="newCanvas" style="display: block;margin: 0 auto;margin-top: 50px;cursor: pointer;" @click="pdfZoom(false)"></canvas>
    </div>
    <div v-show="pdfObject.zoom" style="position: absolute;width:88%;left: 49.5%;top: 10px;transform: translate(-50%,0);z-index:999999;background-color:#fff;">
      <div class="exhibition-header" style="position: static;">
        <div class="exhibition-icon" style="width: 50px;">
          <img v-show="!pdfObject.zoom" src="../../assets/images/common/pdf/enlarge.png" style="margin:10px auto;cursor: pointer;margin-left: 50%;transform: translateX(-50%);
" @click="pdfZoom(true)">
          <img v-show="pdfObject.zoom" src="../../assets/images/common/pdf/narrow.png" style="margin:10px auto;cursor: pointer;margin-left: 50%;transform: translateX(-50%);
" @click="pdfZoom(false)">
        </div>
        <span style="text-align: center;display:block;margin:0 auto;line-height:40px;">
          {{pdfObject.currentIndex}} / {{pdfObject.totalNumber}}
        </span>
      </div>
    </div>
    <img v-show="pdfObject.zoom" src="../../assets/images/common/pdf/left.png" class="newPdf_left" @click="changePage(true)">
    <img v-show="pdfObject.zoom" src="../../assets/images/common/pdf/right.png" class="newPdf_right" @click="changePage(false)">
    <!-- pdf End -->
    <!-- 附件下载框 -->
    <transition name="fade">
      <div class="attachment-modal-box" v-if="showAttachment">
        <div class="attachment-context" @click="closeModal"></div>
        <div class="attachment-modal">
          <div class="attachment-modal-title">文件列表
            <span class="attachment-modal-close" @click="closeModal">x</span>
          </div>
          <div class="attachment-modal-content annex_list">
            <ul>
              <li class="annex_file_name_tit" style="width:20%;">文件名</li>
              <li class="annex_file_size_tit" style="width:10%;">文件大小</li>
              <li class="annex_finger_print_tit" style="width:30%;">数字指纹</li>
              <li class="annex_file_download_tit" style="width:30%;">区块链保全ID</li>
              <li class="annex_file_download_tit" style="width:10%;">操作</li>
            </ul>
            <div class="annex_box">
              <!-- 附件内容 -->
              <ul class="clearfix" v-for="(item, index) in fileList"  :key="index">
                <li class="annex_file_name" style="width:20%;">
                  <!-- <img src="../../assets/images/evidenceTaken/file.png" /> -->
                  <div>
                    <p class="name_content" title="" style="margin-top:0; font-size:12px">{{item.oriFileName}}</p>
                  </div>
                </li>
                <li class="annex_file_size" style="width:10%; font-size:12px">{{item.fileSize1}}</li>
                <li class="annex_finger_print" style="width:30%; font-size:12px;padding:0 5px;">{{item.hashCode}}</li>
                <li class="annex_finger_print" style="width:30%; font-size:12px;padding:0 5px;">{{item.txId}}</li>
                <li class="annex_file_download" style="width:10%; font-size:12px">
                  <a :href="item.downloadLink">
                    <!-- <img src="../../assets/images/evidenceTaken/Download.png" style="display:inline-block" /> -->
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
// 证书左侧预览
import CommonCertificate from "./CommonCertificate";
import SaveCommonCertificate from "./SaveCommonCertificate";
// import PDFJS from "pdfjs-dist"
export default {
  props:{
    nolist:{
      type:Function,
      default:null
    }
  },
  data() {
    return {
      list: {},
      queryUrlParams: {},
      // 图片是否放大
      isPlus: false,
      isHeader: false,
      downloadUrl: "",
      bodyHide: true,
      QRCode: "",
      showAttachment: false,
      canAttachment: false,
      fileList: [],
      IP360: {},
      // 图片是否翻转
      isRotate: false,
      ImgWidth: "",
      ImgHeight: "",
      rotateDeg: "rotate(0deg)",
      deg: 0,
      ImgTop: 0,
      ImgLeft: 0,
      showPic: false,
      canEnlarge: false,
      // 默认为视频可以展示
      showRightsVideo: true,
      // pdf
      pdfObject: {
        zoom: false,
        scale: 1.4,
        newScale: 1.4,
        currentIndex: 1,
        totalNumber: 1,
        path: "",
        loading: false
      },
      clickIndex: false,
      // DOM是否渲染完毕
      domView: false,
      certificateType: "",
      isShowTop: true,
      naturalWidth: 0, //真是宽度
      percentage: 100,
      addOrReduce: 0
    };
  },
  components: { CommonCertificate ,SaveCommonCertificate},
  mounted() {
    this.queryUrlParams = this.$queryUrlParams();
    this.$GlobalConfig.downloadFile.forEach((item)=>{
      if(item.partnerId==this.queryUrlParams.partnerId){
        this.downloadUrl = item.ip + '/extractEvidence/v2/download?';
      }
    })
    // console.log(this.queryUrlParams,"路由的参数")
    if (this.queryUrlParams.uid || this.queryUrlParams.contractFileId) {
      this.IP360 = {
        user: { id: this.queryUrlParams.uid }
      };
      this.isShowTop = false;
    } else {
      this.IP360 = JSON.parse(window.localStorage.getItem("IP360"));
      this.isAttachment();
      this.isShowTop = true;
    }
    this.getCertificate();
  },
  methods: {
    pluss(data) {
      // console.log(data);
      if (this.canEnlarge) {
        this.isPlus = true;
      }
      setTimeout(() => {
        let width = document.getElementById("imgNatural").naturalWidth;
        this.addOrReduce = width * 0.1;
        this.naturalWidth = width;
        // console.log(width);
      }, 1000);
    },
    reset() {
      let width = document.getElementById("imgNatural").naturalWidth;
      this.naturalWidth = width;
      // console.log(this.naturalWidth);
      this.percentage = 100;
    },
    reducePer() {
      // console.log("减少");
      if (this.percentage == 10) {
        return;
      }
      this.naturalWidth = this.naturalWidth - this.addOrReduce;
      // console.log(this.percentage, "this.percentage");
      this.percentage = this.percentage - 10;
      // console.log(this.naturalWidth, "naturalWidth");
    },
    addPer() {
      // console.log("增加");
      // console.log(this.addOrReduce);
      this.naturalWidth = this.naturalWidth + this.addOrReduce;
      this.percentage = this.percentage + 10;
      // console.log(this.naturalWidth, "naturalWidth");
    },
    isAttachment() {
      this.$ajax
        .request({
          url: "/webapi/validateQuery/snapFileList",
          method: "GET",
          params: {
            uid: this.queryUrlParams.uid,
            certificateNumber:this.queryUrlParams.certificateNumber,
            partnerId:this.queryUrlParams.partnerId
          }
        })
        .then(response => {
          if (response.data.code == 200) {
            let resArr = response.data.extraData.list;
            let _this = this;
            if (resArr.length > 0) {
               this.$GlobalConfig.downloadFile.forEach((item)=>{
                  if(item.partnerId==this.queryUrlParams.partnerId){
                     for (let item of resArr) {
                       item.downloadLink = item.ip +"/evidenceTaken/v2/downloadSnapFile?fileId=" +item.id;
                     }
                  }
               })
              // for (let item of resArr) {
              //   item.downloadLink =
              //     this.$GlobalConfig.webApiServer +
              //     "/evidenceTaken/v2/downloadSnapFile?fileId=" +
              //     item.id +
              //     "&token=" +
              //     _this.IP360.user.token;
              // }
              this.fileList = resArr;
              this.canAttachment = true;
            }
          }
        });
    },
    closeModal() {
      this.showAttachment = false;
    },
    attachDownLoad() {
      this.showAttachment = true;
    },
    getCertificate() {
      this.pdfObject.loading = true;
      this.$store.commit("showLoading", true);
      let queryType=this.queryUrlParams.downType ? this.queryUrlParams.downType:this.queryUrlParams.type;
      this.$ajax
        .get("/webapi/validateQuery/getCertificate", {
          params: {
            uid: this.queryUrlParams.uid,
            certificateNumber: this.queryUrlParams.certificateNumber || this.$router.history.current.query.certificateNumber,
            pid:queryType == 8? 1 :'',
            type:
              this.queryUrlParams.type ||
              this.$router.history.current.query.type,
            partnerId: this.queryUrlParams.partnerId,
            certificateToken: "truthso-certificate"
          }
        })
        .then(res => {
          // console.log(res.data,"证书预览");
          var herfPash = window.location.href.split("//")[0]+"//"+window.location.href.split("//")[1].split("/")[0]
          let _this = this;
          var data = res.data.extraData;
          if (res.data.code == 200) {
            this.list = data;
               if (this.$router.history.current.query.type == 1) {
                    this.certificateType = 1;
                    this.downloadUrl =
                      this.downloadUrl +
                      "rightId=" +
                      this.list.id +
                      "&token=" +
                      this.IP360.user.token;
                  } else if (this.$router.history.current.query.type == 2) {
                    this.certificateType = 2;
                    this.downloadUrl =
                      this.downloadUrl +
                      "snapShotId=" +
                      this.list.id +
                      "&token=" +
                      this.IP360.user.token;
                  } else if (this.$router.history.current.query.type == 3) {
                    this.certificateType = 3;
                    this.downloadUrl =
                      this.downloadUrl +
                      "mobileId=" +
                      this.list.id +
                      "&token=" +
                      this.IP360.user.token;
                  } else if (this.$router.history.current.query.type == 6 || this.$router.history.current.query.type == 7 || this.$router.history.current.query.type == 8) {
                    let queryType=this.$route.query.downType ? this.queryUrlParams.downType:this.queryUrlParams.type;
                    let pid=queryType == 7 && this.queryUrlParams.isChild!=0 ? 1 :''
                    //存证
                    this.certificateType = this.$router.history.current.query.type;
                    this.downloadUrl =
                      this.downloadUrl +"preTaskId=" +this.$router.history.current.query.id +
                      "&token=" +this.IP360.user.token +'&type='+queryType+'&pid='+pid;
                  }
            // this.list.filePath = ''
            // console.log(this.list)
            // 二维码
            this.QRCode = res.data.QRCodeUrl;
            this.list.QRCode = res.data.QRCodeUrl;
            // 文档类型加载
            if (this.list.productType == 1) {
              if (this.list.type == 1) {
              //  this.$GlobalConfig.docUrl.forEach(item=>{
              //     if(item.partnerId==this.queryUrlParams.partnerId){
                    // this.pdfObject.path = item.ip + data.filePath.substring(data.filePath.indexOf('.com') + 4)
                    // if(this.queryUrlParams.partnerId==8){//佛山
                    //   this.pdfObject.path =`https://foshanbanbao.oss-cn-beijing.aliyuncs.com/${data.filePath}`
                    // }else{
                      this.pdfObject.path =data.filePath
                    // }
                  // }
                // })
                // console.log(this.pdfObject.path)
                if(data.filePath){
                   setTimeout(function() {
                      _this.pdfRender();
                      _this.pdfObject.loading = false;
                      //_this.showRightsVideo = false
                    }, 1000);
                }else{
                    _this.pdfObject.loading = false;
                }
              }
            }
            
            // 翻转图片
            if (this.list.productType == 3) {
              // console.log("imageSize:", this.list.imageSize)
              if (this.list.imageSize) {
                this.list.imageSize = JSON.parse(
                  this.list.imageSize.substring(
                    1,
                    this.list.imageSize.length - 1
                  )
                );

                if (this.list.imageSize.width > this.list.imageSize.height) {
                  // _this.isRotate = false
                  _this.rotateDeg = "rotate(0deg)";
                } else {
                  // _this.isRotate = true
                  _this.rotateDeg = "rotate(90deg)";
                }
              }
            }
            // 图片放大
            if ((this.list.type == 2 && this.$route.query.partnerId != 23) || this.list.type == 50001) {
              this.isHeader = true;
              var img = new Image();
              img.src = this.list.filePath;
              img.onload = function() {
                _this.ImgWidth = img.width;
                _this.ImgHeight = img.height;
                if (_this.ImgWidth > 458) {
                  _this.ImgHeight = _this.ImgHeight * (458 / _this.ImgWidth);
                  _this.ImgWidth = 457;
                  _this.canEnlarge = true;
                }
                if (_this.ImgHeight > 521) {
                  _this.ImgWidth = _this.ImgWidth * (521 / _this.ImgHeight);
                  _this.ImgHeight = 520;
                  _this.canEnlarge = true;
                }
                _this.ImgTop = (521 - _this.ImgHeight) / 2 + "px";
                _this.ImgLeft = (458 - _this.ImgWidth) / 2 + "px";
                _this.ImgWidth += "px";
                _this.ImgHeight += "px";
                _this.showPic = true;
              };
            }
            //对接调节平台单独处理
            if(this.$route.query.partnerId == 23){
              if (this.list.type == 2) {
              //  this.$GlobalConfig.docUrl.forEach(item=>{
              //     if(item.partnerId==this.queryUrlParams.partnerId){
                    // this.pdfObject.path = item.ip + data.filePath.substring(data.filePath.indexOf('.com') + 4)
                    // if(this.queryUrlParams.partnerId==8){//佛山
                    //   this.pdfObject.path =`https://foshanbanbao.oss-cn-beijing.aliyuncs.com/${data.filePath}`
                    // }else{
                      this.pdfObject.path =data.filePath
                    // }
                  // }
                // })
                // console.log(this.pdfObject.path)
                if(data.filePath){
                   setTimeout(function() {
                      _this.pdfRender();
                      _this.pdfObject.loading = false;
                      //_this.showRightsVideo = false
                    }, 1000);
                }else{
                    _this.pdfObject.loading = false;
                }
              }
            }
            // 视频是否支持播放
            // 数据更新: nextTick, 渲染完成: $nextTick
            this.$nextTick(function() {
              if (_this.list.type == 4 || (_this.$route.query.partnerId == 23&&_this.list.type == 3)) {
                _this.$refs.video.addEventListener(
                  "canplaythrough",
                  function() {
                    if (_this.$refs.video.duration) {
                      _this.showRightsVideo = true;
                    } else {
                      _this.showRightsVideo = false;
                    }
                  }
                );
                _this.$refs.video.addEventListener("error", function() {
                  _this.showRightsVideo = false;
                });
              }
              _this.domView = true;
            });
            // console.log(_this.$refs.video)
            // console.log(_this.$refs.video.duration)
            // console.log(_this.showRightsVideo)
            // console.log(_this.domView)
          }else if(res.data.code==402){
            this.$emit("nolist",true)
              // console.log("为查询到数据")
          }
          this.bodyHide = false;
          this.$store.commit("showLoading", false);
          //console.log("list:", this.list)
          // console.log("bodyHide:", this.bodyHide)
        });
    },
    back(is) {
      if (is) {
        this.$router.go(-1);
      } else {
        this.$router.push(".");
      }
    },
    imgRotate() {
      this.deg += 90;
      this.rotateDeg = "rotate(" + this.deg + "deg)";
    },
    reduce() {
      if (this.canEnlarge) {
        this.isPlus = false;
      }
    },
    plus() {
      if (this.canEnlarge) {
        this.isPlus = true;
      }
    },
    pdfZoom(is) {
      this.pdfObject.zoom = is;
    },
    // pdf切换页码
    changePage(is) {
      if (this.clickIndex) {
        if (is) {
          if (this.pdfObject.currentIndex <= 1) {
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: "当前是第一页"
            });
            return false;
          } else {
            this.pdfObject.currentIndex--;
          }
        } else {
          if (this.pdfObject.currentIndex >= this.pdfObject.totalNumber) {
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: "当前是最后一页"
            });
            return false;
          } else {
            this.pdfObject.currentIndex++;
          }
        }
        this.clickIndex = false;
        // console.log("Start/render:", this.clickIndex)
        this.pdfRender();
      }
    },
    pdfRender() {
      // console.log(PDFJS)
      var _this = this;
      var canvas = _this.$refs.theCanvas;
      var newCanvas = _this.$refs.newCanvas;
      var url = _this.pdfObject.path;
      // console.log(url ,'pdf url')
      // var url = '../../assets/images/1.pdf';
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.pdfObject.totalNumber = pdf.numPages;
        pdf
          .getPage(_this.pdfObject.currentIndex)
          .then(function getPageHelloWorld(page) {
            /* Canvas Start */
            var scale = _this.pdfObject.scale;
            var viewport = page.getViewport(scale);
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            /* Canvas End */

            /* new Canvas Start */
            var newScale = _this.pdfObject.newScale;
            var newViewport = page.getViewport(newScale);
            var newContext = newCanvas.getContext("2d");
            newCanvas.width = newViewport.width;
            newCanvas.height = newViewport.height;
            var newRenderContext = {
              canvasContext: newContext,
              viewport: newViewport
            };
            /* new Canvas End */
            page.render(renderContext);
            page.render(newRenderContext);
            setTimeout(function() {
              _this.clickIndex = true;
              _this.pdfObject.loading = false;
              // console.log("End/render:", _this.clickIndex);
            }, 500);
          });
      });
    }
  }
};
</script>

<style scoped>
.preview {
  width: 162px;
  height: 22px;
  position: absolute;
  left: 50%;
  top: 22%;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  overflow: hidden;
}
.preview .num {
  display: block;
  width: 50px;
  background: #fff;
  text-align: center;
  height: 22px;
  color: #999999;
  float: left;
  border: 1px solid #cacaca;
  border-left: none;
  border-right: none;
}
.preview .add {
  font-size: 20px;
  border: 1px solid #cacaca;
  line-height: 17px;
  text-align: center;
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: block;
  color: #999999;
  float: left;
  background: #efefef;
}
.reset {
  cursor: pointer;
  width: 50px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  display: block;
  margin-left: 16px;
  color: #999999;
  background: #efefef;
  float: left;
}
.reset:hover {
  color: #fff;
  background: #cc4455;
}
.preview .add:hover {
  color: #fff;
  background: #cc4455;
}
.hide {
  display: none;
}

* {
  font-family: "微软雅黑";
}

.content {
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
}

.top {
  width: 100%;
  /*margin: 20px auto;*/
  margin-bottom: 20px;
  height: 50px;
  border-radius: 3px;
  /*border: solid 1px #b5b8bc;*/
  /*line-height: 100px;*/
  text-align: center;
}

.right-download {
  text-align: center;
  margin-left: 50px;
}

.middle-download,
.right-download,
.back {
  color: #666666;
  border: solid 1px #cfcfcf;
  width: 100px;
  height: 34px;
  border-radius: 3px;
  background-color: #fff;
  line-height: 34px;
  font-size: 14px;
  cursor: pointer;
  display: inline-block;
  margin-top: 25px;
}

.middle-download:hover,
.right-download:hover,
.back:hover {
  border-color: #da1f35;
  color: #cc4455;
}

.back {
  margin-right: 40px;
}

/* 证书显示页 */
.see {
  width: 470px;
  height: 651px;
  /* background: url(../../assets/images/common/certificate.png) no-repeat center; */
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  /* background: url(../../assets/images/common/certificate-title.png) no-repeat */
    /* center; */
}

.see > .introduce {
  width: 400px;
  line-height: 22px;
  /*margin: 5px 0 0 55px;*/
  margin: 10px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see > .username {
  width: 370px;
  margin: 0 auto;
}

.see > .abstract {
  width: 370px;
  margin: 0 auto;
}
.see > .name {
  margin-left: 86px;
}

.see > .file,
.see > .time,
.see > .type,
.see > .size,
.see > .format {
  width: 370px;
  /*margin: 0 auto;*/
  margin-left: 74px;
}

.see > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translate(-50%, 0);
}

.see > .issue > p {
  font-size: 12px;
  line-height: 12px;
  margin-top: 5px;
}

.SHA512 {
  width: 324px;
  display: block;
  word-wrap: break-word;
}

.name,
.file,
.time,
.type,
.size,
.format {
  margin: 4px 0 0 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 证书展示页 */
.exhibition {
  width: 460px;
  height: 690px;
  border: solid 1px #c2c3c4;
  float: right;
  margin-top: 32px;
  position: relative;
  background: #fff;
}

.exhibition-header {
  width: 100%;
  height: 45px;
  border-bottom: solid 1px #b4bec3;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
}

.exhibition-icon {
  width: 100px;
  height: 45px;
  float: right;
  border-left: solid 1px #b4bec3;
}

.exhibition-icon > div {
  width: 49px;
  height: 45px;
  cursor: pointer;
}

.exhibition-content {
  width: 100%;
  height: 100%;
  padding-top: 45px;
}

.exhibition-content > div {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}

/* 容器 */
.certificate {
  padding-bottom: 70px;
}

.reduce {
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 15px;
}

.plus {
  margin-top: 9px;
  margin-left: 8px;
}

.reduce,
.plus {
  float: left;
  /*cursor: pointer;*/
}

.see > div {
  width: 80%;
  word-wrap: break-word;
  line-height: 16px;
}

/* 图片放大缩小 */
.narrow {
  width: 70%;
  height: 70%;
}

._narrow {
  width: 100%;
  height: 100%;
}

/* 图片放大缩小 */
audio {
  width: 100%;
  height: 386px;
}

/*s*/
video {
  width: 100%;
  height: 386px;
}

.exhibition-content .img-content {
  overflow: hidden !important;
  width: 458px;
  height: 521px;
}

.QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 17px;
  left: 50px;
  /* background: url(../../assets/images/common/certificate-QRCode.png) no-repeat
    center; */
  padding: 2px;
}

.QRCode > img {
  width: 55px;
  height: 55px;
}

.content {
  padding-left: 30px;
  padding-right: 30px;
}

.certificate {
  width: 990px;
  margin: 0 auto;
  text-align: center;
  height: 720x;
  position: relative;
}

.position {
  width: 950px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.annex_list {
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
}

.annex_list > ul {
  width: 100%;
  height: 32px;
  background: #f2f2f2;
  font-size: 14px;
  color: #656565;
}

.annex_list > ul li {
  height: 32px;
  line-height: 32px;
  font-weight: bold;
  float: left;
}

.annex_box {
}

.annex_box ul {
  width: 100%;
  min-height: 56px;
  padding: 6px 0 6px;
  border-bottom: 1px solid #f2f2f2;
  overflow: hidden;
}

.annex_box ul li {
  float: left;
  min-height: 56px;
}

.annex_box .annex_file_name {
  word-wrap: break-word;
  overflow: hidden;
}

.annex_box .annex_file_name img {
  float: left;
  padding-left: 18px;
  padding-top: 20px;
}

.annex_box .annex_file_name div {
  float: left;
  height: 56px;
  width: 78%;
  margin-left: 0px;
  overflow: hidden;
  position: relative;
}

.annex_box .annex_file_name div .name_content {
  margin: 0;
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  word-wrap: break-word;
  line-height: 14px;
  transform: translate(-50%, -50%);
}

.annex_box .annex_file_name div .ie8 {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  height: 56px;
  line-height: 56px;
}

.annex_file_size,
.annex_file_download {
  line-height: 56px;
}

.annex_box .annex_finger_print {
  font-size: 12px;
  color: #656565;
  word-wrap: break-word;
  text-align: left;
}

.annex_file_download {
  cursor: pointer;
}

.attachment-modal-box,
.attachment-context {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
}

.attachment-context {
  background-color: rgba(0, 0, 0, 0.4);
}

.attachment-modal {
  position: absolute;
  width: 900px;
  left: 50%;
  top: 40%;
  z-index: 999999;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 16px;
}

.attachment-modal-title {
  height: 50px;
  line-height: 50px;
  background-color: #d03346;
  color: #fff;
  padding-top: 1px;
  margin-top: -1px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-align: center;
  position: relative;
}

.attachment-modal-close {
  position: absolute;
  right: 13px;
  top: 0;
  display: block;
  text-align: center;
  cursor: pointer;
}

.attachment-modal-content {
  text-align: center;
}

/*transition Start*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.text-overflow {
  /*word-break: break-all;*/
  /*text-overflow: ellipsis;*/
  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 2;*/
  /*overflow: hidden;*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

._rotate {
  transform: rotate(90deg) !important;
}

.isPlus {
  width: auto !important;
  height: auto !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
}

.cursor_not_allowed {
  cursor: not-allowed !important;
}

.exhibition-content .img-content.scrolled {
  overflow: scroll !important;
}

.padding_top {
  padding-top: 0px;
}

/*transition End*/
/* pdf Start */
.pdf_left,
.pdf_right {
  position: absolute;
  top: 50%;
  cursor: pointer;
}
.pdf_left {
  left: 20px;
}
.pdf_right {
  right: 20px;
}
.newPdf_left,
.newPdf_right {
  position: absolute;
  top: 50%;
  cursor: pointer;
  z-index: 999999;
}
.newPdf_left {
  left: 8%;
}
.newPdf_right {
  right: 8%;
}
.pdf_box,
.img_box {
  position: absolute;
  overflow: scroll;
  left: 50%;
  transform: translate(-50%, 0);
  top: 10px;
  width: 90%;
  height: 90%;
  background-color: #fff;
  z-index: 99999;
}
.pdf_modal,
.img_modal {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  left: 0;
  top: 0;
  z-index: 99999;
}

.pdfLoading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999999;
}
.pdfLoading > img {
  /*width: 48px;*/
  /*height: 48px;*/
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
/* pdf End */

.certificate-number {
  text-align: center;
  /*margin-top: 5px;*/
  width: 100% !important;
}

/* 老证书 */
.new_see {
  width: 440px;
  height: 650px;
  /* background: url(../../assets/images/common/_newcertificate.png) no-repeat */
    /* center; */
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}
.new_see > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see > .introduce {
  width: 324px;
  line-height: 22px;
  margin: 5px 0 0 55px;
}

.new_see > .abstract {
  width: 324px;
  margin: 1px 0 0 55px;
  text-align: left;
}

.new_see > .SHA512 {
  width: 324px;
  display: block;
  word-wrap: break-word;
}

.new_see > .username,
.new_see > .name,
.new_see > .file,
.new_see > .time,
.new_see > .type,
.new_see > .size,
.new_see > .format,
.new_see > .issue {
  width: 350px;
  margin: 4px 0 0 55px;
}

.new_see > .QRCode {
  width: 92px;
  height: 92px;
  position: absolute;
  bottom: 45px;
  left: 55px;
}

.new_see > .QRCode > img {
  width: 100%;
  height: 100%;
}
</style>
